// extracted by mini-css-extract-plugin
export default {"link":"Modal_link__rwDfD","modalOverlay":"Modal_modalOverlay__F13Jm","modalInner":"Modal_modalInner__fmiyA","modalBtn":"Modal_modalBtn__8VY1s"};